import { Autocomplete, TextField } from '@mui/material';
import i18n from 'i18next';
import { PropTypes } from 'prop-types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import CaseType from '../../../enums/CaseType';
import { getCurrentTranslation } from '../../../utils/helpers';
import { trpc } from '@/config/trpc';

const propTypes = {
  callback: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  defaultValue: PropTypes.arrayOf(PropTypes.object),
  label: PropTypes.string,
  name: PropTypes.string,
};

const ClassificationFilter = ({
  callback = () => {},
  name = '',
  defaultValue = [],
  label = null,
}) => {
  const { language } = i18n;
  const { t } = useTranslation('common');

  const { data: caseClassificationsData = [] } = trpc.team.case.classification.list.useQuery({
    caseTypes: [CaseType.Case],
  });

  const caseClassifications = useMemo(
    () =>
      caseClassificationsData.toSorted((a, b) => {
        const translationA = getCurrentTranslation(a.translations, language) ?? '';
        const translationB = getCurrentTranslation(b.translations, language) ?? '';
        return translationA.localeCompare(translationB);
      }),
    [caseClassificationsData, language],
  );

  return (
    <Autocomplete
      filterSelectedOptions
      getOptionLabel={(opt) => {
        if (opt === null) return '';
        const classification = caseClassifications.find((c) => c.id === opt.id);
        if (classification == null) return '';
        const currentTranslation = getCurrentTranslation(classification.translations, language);
        return currentTranslation ?? '';
      }}
      getValue={(val) => val?.id ?? val}
      id="classificationId"
      isOptionEqualToValue={(option, value) => option.id === value.id}
      label={t('common:classification')}
      noOptionsText={t('common:noOptions')}
      options={caseClassifications}
      renderInput={(params) => (
        <TextField {...params} label={label ?? t('common:classification')} variant="standard" />
      )}
      value={defaultValue}
      onChange={(e, values) => callback(name, values)}
    />
  );
};

ClassificationFilter.propTypes = propTypes;

export default ClassificationFilter;
